function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 22.8,
  height: 22.8,
  x: 0.6000000000000001,
  y: 0.6000000000000001,
  rx: 3,
  ry: 3,
  strokeWidth: 1.2000000000000002,
  stroke: "white",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  r: 3,
  cx: 9.600000000000001,
  cy: 5.4,
  fill: "none",
  stroke: "white",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 9.600000000000001,
  x2: 10.2,
  y1: 8.4,
  y2: 13.799999999999999,
  stroke: "white",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M 4.800000000000001 7.199999999999999 L 4.5600000000000005 11.339999999999998 L 9.9 11.1 L 18 7.199999999999999",
  stroke: "white",
  strokeWidth: 1.5,
  fill: "none"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M 8.399999999999999 21.6 L 10.2 13.799999999999999 L 12.6 16.92 L 12 21.6",
  stroke: "white",
  strokeWidth: 1.5,
  fill: "none"
});

function SvgLogo24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMinYMin meet",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo24);
export default __webpack_public_path__ + "static/media/logo_24.8e548d9d.svg";
export { ForwardRef as ReactComponent };